/* ------------ Types ------------ */
export type CarTrip = {
    mot: ModeOfTransport.CAR;
    distance: number; 
    engineType: EngineType;
    frequency: number; 
    interval: Interval;
    toCustomer: boolean;
}

export type BikeTrip = {
    mot: ModeOfTransport.BIKE;
    distance: number; 
    frequency: number; 
    interval: Interval;
    toCustomer: boolean;
}

export type TrainTrip = {
    mot: ModeOfTransport.TRAIN;
    distance: number; 
    frequency: number; 
    interval: Interval;
    toCustomer: boolean;
}

export type TripType = CarTrip | TrainTrip | BikeTrip;

export type Reminder = {
    date: Date;
    urgent: boolean;
}

export type Campaign = {
    id: string;
    endDate: Date;
    name: string;
    userStatuses: User[];
    reminders: Reminder[];
}

export type CampaignParticipation = {
    id: {
        campaignId: string;
        userEmail: string;
    }; 
    trips: TripType[];
}

export type User = {
    email: string;
    name: string;
    status: Status;
}

export type Info = {
    isAdmin: boolean;
    campaignName: string;
    campaignParticipation: CampaignParticipation;
}

/* ------------ ENUMS ------------ */
export enum Status {
    EMPTY,
    OLD,
    UP_TO_DATE,
}

export enum EngineType {
    ELECTRIC = "Elektroauto",
    PETROL = "Benziner",
    DIESEL = "Diesel"
}

export enum Interval {
    WEEK = "Woche",
    MONTH = "Monat",
    YEAR = "Jahr"
}

export const IntervalDays: Record<Interval, number> = {
    [Interval.WEEK]: 7,
    [Interval.MONTH]: 31,
    [Interval.YEAR]: 365
}

export enum ModeOfTransport {
    CAR = "Auto",
    TRAIN = "Bahn",
    BIKE = "Fahrrad"
}